import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';


@Component({
  providers: [],
  selector: 'app-root',
  template: `
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{modalTitle}}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <pdf-viewer [src]="modalPdf" [render-text]="true" style="display:block">
        
      </pdf-viewer>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-info" (click)="bsModalRef.hide()">{{closeBtnName}}</button>
    </div>
  `
  // templateUrl: './view-book-modal.component.html'
})
export class ViewBookModalComponent implements OnInit {
  modalTitle: string;
  modalPdf: string;
  closeBtnName: string;
  list: any[] = [];
 
  constructor(public bsModalRef: BsModalRef, private modalService: BsModalService) {}
  ngOnInit() {}
}

